//src/pages/SupportPage.jsx

import { useState } from "react";
import { useParams } from "react-router-dom";
import { initiateSupportPayment } from "../services/support";

const SupportPage = () => {
  const { slug: creatorName, packageType } = useParams();

  const [email, setEmail] = useState("");
  const [customAmount, setCustomAmount] = useState("");
  const [loading, setLoading] = useState(false);

  // =========================
  // PACKAGE MAP
  // =========================

  const packageMap = {
    coffee: 1000,
    burger: 5000,
    crown: 10000,
  };

  const isCustom = packageType === "custom";

  const amount = isCustom
    ? Number(customAmount)
    : packageMap[packageType];

  // =========================
  // PAYMENT HANDLER
  // =========================

  const handlePay = async () => {
    if (!email) {
      alert("Please enter email");
      return;
    }

    if (!amount || amount <= 0) {
      alert("Invalid amount");
      return;
    }

    try {
      setLoading(true);

      const res = await initiateSupportPayment({
        email,
        slug: creatorName,
        amount,
      });

      console.log("SUPPORT RESPONSE:", res);

      const paymentLink =
        res?.data?.link ||
        res?.link ||
        res?.payment_link;

      if (paymentLink) {
        window.location.href = paymentLink;
      } else {
        alert("Payment link not generated");
      }
    } catch (err) {
      console.error("Support payment error:", err);
      alert("Payment failed");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // INVALID PACKAGE
  // =========================

  if (!isCustom && !amount) {
    return (
      <div className="container">
        <h2>Invalid package</h2>
      </div>
    );
  }

  return (
    <div className="container">

      <h2>Support Creator</h2>

      {/*TRUST BAR*/}

      <div
        style={{
          marginTop: 10,
          marginBottom: 20,
          padding: "14px 18px",
          borderRadius: 14,
          background: "#fff",
          border: "2px solid #f1f5f9",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 10,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 16,
              fontWeight: "bold",
              color: "#111827",
            }}
          >
            🔒 Payments Secured by Flutterwave
          </div>

          <div
            style={{
              fontSize: 13,
              color: "#6b7280",
              marginTop: 4,
            }}
          >
            Trusted payment infrastructure powering creator support payouts.
          </div>
        </div>

        <div
          style={{
            background: "#fb923c",
            color: "#fff",
            padding: "8px 14px",
            borderRadius: 999,
            fontWeight: "bold",
            fontSize: 13,
          }}
        >
          VERIFIED PAYMENT SYSTEM
        </div>
      </div>

      <div className="card">

        <p>
          <b>Creator:</b> {creatorName}
        </p>

        <p>
          <b>Package:</b> {packageType}
        </p>

        <p>
          <b>Amount:</b> ₦{amount || 0}
        </p>

        {isCustom && (
          <input
            className="input"
            placeholder="Enter custom amount"
            type="number"
            value={customAmount}
            onChange={(e) => setCustomAmount(e.target.value)}
          />
        )}

        <p style={{ marginTop: 10 }}>
          People are already supporting this Creator
        </p>

        <input
          className="input"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button
          className="button"
          onClick={handlePay}
          disabled={loading}
        >
          {loading
            ? "Processing..."
            : "Continue to Payment"}
        </button>

      </div>
    </div>
  );
};

export default SupportPage;